import {combineReducers, configureStore} from '@reduxjs/toolkit'
import {useDispatch} from "react-redux";
import userReducer from './reducers/UserSlice'
import transactionsReducer from './reducers/TransactionsSlice/TransactionsSlice'
import storageSession from 'redux-persist/lib/storage/session'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import {persistReducer} from 'redux-persist'
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';

const persistConfig = {
    key: 'root_redux',
    storage: storageSession,
    stateReconciler: hardSet,
}

const rootReducer = combineReducers({
    userReducer,
    transactionsReducer,
})

export const setupStore = (
    initialState?: any
) => {

    const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(persistConfig, rootReducer)

    const sagaMiddleware = createSagaMiddleware();


    const store = configureStore({
        reducer: persistedReducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }).concat(sagaMiddleware),
    });

    sagaMiddleware.run(rootSaga);

    return store;
};


// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch


export type AppStore = ReturnType<typeof setupStore>
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = AppStore['dispatch']
export const useAppDispatch: () => AppDispatch = useDispatch
